import { useQuery } from "@tanstack/react-query";
import { getSameDayCancellations } from "@/http/sameDayCancellationApi";
import type { SameDayCancellation } from "@/@types/sameDayCancellation.types";
import { getSameDayCancellationsQueryKey } from "@/utils/queryKeys";
import { useAuth } from "@/contexts/AuthContext";

export const useGetSameDayCancellationsQuery = (params?: { enabled?: boolean }) => {
  const { authPhone } = useAuth();
  const { enabled = true } = params || {};

  return useQuery<SameDayCancellation[]>({
    queryKey: [...getSameDayCancellationsQueryKey(), { phone: authPhone }],
    queryFn: async () => {
      const response = await getSameDayCancellations(authPhone);
      return response.data.data;
    },
    enabled: enabled && !!authPhone,
  });
};
